import CascadeFilter from "@shared/components/CascadeFilter";
import {
  ActualEntryFilterNode,
  ActualEntryFilterOption,
  ActualEntryFilterValue,
} from "../../../types/maintenanceWorkflowActualEntryFilter.type";

interface ActualEntryCascadeFilterProps {
  tree: ActualEntryFilterNode[];
  value?: ActualEntryFilterOption | null;
  onChange: (value: ActualEntryFilterOption | null) => void;
  className?: string;
}

const sameValue = (a: ActualEntryFilterValue, b: ActualEntryFilterValue) =>
  a.relation === b.relation &&
  (a.entry_klass ?? null) === (b.entry_klass ?? null) &&
  (a.status ?? null) === (b.status ?? null);

const nodeKey = (node: ActualEntryFilterNode) =>
  `${node.value.relation}-${node.value.entry_klass ?? ""}-${node.value.status ?? ""}`;

const ActualEntryCascadeFilter = ({ tree, value, onChange, className }: ActualEntryCascadeFilterProps) => (
  <CascadeFilter
    tree={tree}
    value={value}
    onChange={onChange}
    isSameValue={sameValue}
    getNodeKey={nodeKey}
    placeholder="Etapa atual"
    clearLabel="Limpar"
    triggerTestId="actual_entry_filter"
    panelTestId="actual_entry_panel"
    clearTestId="actual_entry_filter_clear"
    className={className}
  />
);

export default ActualEntryCascadeFilter;
